/* eslint-disable no-undef */
import AgoraRtmMixin from "@/mixins/AgoraRtmMixin";
import { agoraOptions, LOCAL_CHAT_CONFIG, RTM_CONFIGS, STREAM_MESSAGES_CONFIG } from "@/configs/Settings";
import { uuid } from "vue-uuid";
import InputHelperMixin from "@/mixins/InputHelperMixin";
import { RTM_MESSAGE_TYPE } from "@/configs/RTM_SDK";
import { mapActions, mapGetters } from "vuex";
import faker from "faker";
import HelperMixins from "@/mixins/HelperMixins";
import SwitchCheckbox from "@/components/SwitchCheckbox";
import { CHAT_APIs } from "@/configs/APIs";
import ConfirmModal from "@/components/ConfirmModal";
export default {
   name: "ChatBox",
   components: {
      SwitchCheckbox, 
      ConfirmModal
   },
   mixins: [AgoraRtmMixin, InputHelperMixin, HelperMixins],
   props: {
      showAds: {
         type: Boolean,
         default: false
      },
      showingDebug: {
         type: Boolean,
         default: false
      },
      urlSources: {
         type: Array,
         default: function() {
            return [];
         }
      },
      urlPlaying: {
         type: String,
         default: ""
      }
   },
   data() {
      return {
         uuid: uuid.v1(),
         isAtBottom: true,
         jobSaveChatId: null,
         delayTimeSaveChatLog: LOCAL_CHAT_CONFIG.DELAY_TIME_TO_SAVE,
         streamMessagesConfig: STREAM_MESSAGES_CONFIG,
         autoGenerateMessage: false,
         autoGenerateMessageId: null,
         autoGenerateTimePerMessage: STREAM_MESSAGES_CONFIG.TIME_PER_MESSAGE,
         isRandomTextMessage: false,
         indexTestMessage: 0,
         isSavingMessageLocal: false,
         listOpacity: [],

         // Testing debug:
         urlTesting: "",
         tokenTesting: "",
         isJwtToken: false,
         eventKey: this.$route.params.slug,
         deleteModal: {
            modalId: `delete-modal`,
            title: "Do you want to delete this message?",
            content: ""
         },
         selectedMsg: null,
         intervalGetMemberId: null,
         isStreamEnded: false
      };
   },
   watch: {
      listChannelMessages: function() {
         this.$nextTick(() => {
            if (this.isAtBottom) {
               this.scrollToEndChatBox();
            }
         });
      },
      showAds(newVal) {
         if (newVal) document.documentElement.style.setProperty("--adsHeight", `10vh`);
         else document.documentElement.style.setProperty("--adsHeight", `0vh`);
         this.onResize();
      },
      listYourMessages: function() {
         if (!this.isSavingMessageLocal && this.listYourMessages.length >= LOCAL_CHAT_CONFIG.MAXIMUM_MESSAGES) {
            this.clearJobSaveChatLog();
            this.updateYourChatLog(this.listYourMessages);
         } else if (this.listYourMessages.length && !this.jobSaveChatId) {
            this.createJobSaveChatLog();
         }
      },
      autoGenerateMessage(val) {
         if (val && !this.autoGenerateMessageId) {
            this.indexTestMessage = 0;
            this.autoGenerateMessages();
         } else if (!val) {
            this.clearAutoGenerateMessages();
         }
      },
      autoGenerateTimePerMessage(newVal, oldVal) {
         if (this.autoGenerateMessage && newVal !== oldVal) {
            this.clearAutoGenerateMessages().then(() => {
               this.indexTestMessage = 0;
               this.autoGenerateMessages();
            });
         }
      },
      isRandomTextMessage(val) {
         if (val) {
            this.indexTestMessage = 0;
         }
      },
      currentChannel(val) {
         if (val && !this.isJoinedChannel) {
            this.initialAgoraRTM();
         }
      }
   },
   computed: {
      ...mapGetters(["listYourMessages", "user", "streamDetail", "isLoggedInRtm", "currentChannel", "isJoinedChannel", "streamStatistic"]),
      getDurationNextMsg() {
         return this.waitDuration < 0 ? "REJECT" : `${this.waitDuration} seconds`;
      },
      performance() {
         return window.performance;
      }
   },
   async mounted() {
      if (this.$refs.messageDisplay) {
         this.$refs.messageDisplay.addEventListener("scroll", this.handleScrollingChatBox);
         this.scrollToEndChatBox();
      }
      this.$root.$on("stream-ended", async () => {
         this.isStreamEnded = true;
         await this.updateYourChatLog(this.listYourMessages);
      });
      document.getElementById("list-messages-box").addEventListener("scroll", this.getElementOverflow);
   },
   methods: {
      ...mapActions([
         "updateListYourMessages",
         "updateListChannelMessages",
         "addNewChannelMessages",
         "updateIsJoinedChannel",
         "updateCurrentChannel",
         "removeNumberMessagesFromStartOfListYourMessages",
         "updateStreamEnded"
      ]),
      startPlayVideo(url, token = "", isJwt = false) {
         if (url) {
            this.$emit("updateUrlTesting", url, token, isJwt);
         }
      },
      handleScrollingChatBox(event) {
         if (Math.round(event.target.scrollTop + event.target.clientHeight) >= Math.round(event.target.scrollHeight) - 5) this.isAtBottom = true;
         // 5px
         else this.isAtBottom = false;
      },
      scrollToEndChatBox: function() {
         let container = this.$refs.messageDisplay;
         if (container) container.scrollTop = container.scrollHeight;
      },
      enterPressed() {
         this.sendMsg(this.stringInput);
      },
      sendMsg(message) {
         if (!message) return;
         this.stringInput = "";
         let messageObjectForSend = this.formatMessageChannelBeforeSend(message.trim());
         if (messageObjectForSend) {
            this.sendNewChannelMessage(messageObjectForSend, this.currentChannel);
         }
         this.$refs.chatInput.blur();
         this.scrollToEndChatBox();
      },

      afterJoinedChannelSuccess: function() {
         this.updateIsJoinedChannel(true);
         // if (!this.intervalGetMemberId) {
         //    this.intervalGetMemberId = setInterval(() => {
         //       this.getChannelMemberCountJob();
         //    }, STREAM_CONFIGS.TIME_GET_STATISTIC * 1000)
         // }
      },

      getChannelMemberCountJob() {
         this.getChannelMemberCount([this.currentChannel]);
      },

      async clearGetMemberJob() {
         clearInterval(this.intervalGetMemberId);
         this.intervalGetMemberId = null;
      },

      async clearAutoGenerateMessages() {
         clearInterval(this.autoGenerateMessageId);
         this.autoGenerateMessageId = null;
      },
      autoGenerateMessages() {
         /*
          * Send test messages stream:
          */
         this.autoGenerateMessageId = setInterval(() => {
            // this.sendMsg(faker.lorem.text());
            if (this.isRandomTextMessage) {
               this.sendMsg(faker.lorem.text());
            } else {
               this.indexTestMessage++;
               this.sendMsg(`Message ${this.indexTestMessage}`);
            }
            // let messageObjectForSend = this.formatMessageChannelBeforeSend(faker.lorem.text());
            // this.addNewChannelMessages(messageObjectForSend);
         }, this.autoGenerateTimePerMessage);
      },

      sendLikeMsg(isLiked) {
         let messageObjectForSend = this.formatMessageChannelBeforeSend(
            {
               Message: "liked video!",
               IsLiked: isLiked
            },
            RTM_MESSAGE_TYPE.LIKE
         );
         if (messageObjectForSend) {
            this.sendNewChannelMessage(messageObjectForSend, this.currentChannel);
         }
      },

      initialAgoraRTM: function() {
         this.logoutAgoraRtm().then(() => {
            this.initAgoraRtm(agoraOptions.appID, this.uuid);
         });
      },
      afterLoggedInAgoraRtm: function() {
         if (this.currentChannel) {
            this.joinChannelRtm(this.currentChannel, RTM_CONFIGS.CHANNEL_EVENTS, "receivedChat");
            this.joinChannelRtm(this.streamDetail.key, ["ChannelMessage"], "receivedAdmin");
         }
      },
      createJobSaveChatLog() {
         this.jobSaveChatId = setInterval(() => {
            this.updateYourChatLog(this.listYourMessages);
         }, this.delayTimeSaveChatLog * 1000);
      },
      async updateYourChatLog(listLocalMessages) {
         if (!listLocalMessages.length) {
            if (this.isStreamEnded) {
               this.updateStreamEnded(true);
            }
            return;
         }

         this.isSavingMessageLocal = true;

         let dataLog = {
            chatrecords: listLocalMessages
         };

         let dataRequest = {
            slug: this.eventKey,
            data: JSON.stringify(dataLog)
         };

         this.$http
            .post(CHAT_APIs.UPDATE_CHAT_CHANNEL, dataRequest)
            .then((response) => {
               console.log(response);
               if (response.data) {
                  this.removeNumberMessagesFromStartOfListYourMessages(listLocalMessages.length);
                  this.isSavingMessageLocal = false;
               }
            })
            .catch((error) => {
               console.log(error);
            })
            .then(() => {
               if (this.isStreamEnded) {
                  this.updateStreamEnded(true);
               }
            });
      },
      clearJobSaveChatLog() {
         clearTimeout(this.jobSaveChatId);
         this.jobSaveChatId = null;
      },
      convertBytesToSize(bytes) {
         return this.bytesToSize(bytes);
      },
      isOverflown(e) {
         const { offsetTop, offsetHeight } = e;
         const chatBoxElement = document.getElementById("list-messages-box");
         let opacity = 1;
         if (offsetTop < chatBoxElement.scrollTop) {
            opacity = (offsetTop + offsetHeight - chatBoxElement.scrollTop) / 100;
            opacity = opacity * 1.5;
         } else if (offsetTop + offsetHeight > chatBoxElement.scrollTop + chatBoxElement.clientHeight) {
            opacity = (chatBoxElement.scrollTop + chatBoxElement.clientHeight - offsetTop) / 100;
            opacity = opacity * 1.5;
         } else {
            opacity = 1;
         }
         return opacity;
      },
      getElementOverflow() {
         var els = document.querySelectorAll("[id^='message-']");
         let newListOpacity = [];
         for (var i = 0; i < els.length; i++) {
            newListOpacity.push(this.isOverflown(els[i]));
         }
         this.listOpacity = newListOpacity;
      },
      getOpacity(index) {
         return this.listOpacity[index] || 1;
      },
      showConfirmDeleteModal(msg) {
         this.selectedMsg = msg;
         this.deleteModal.content = msg.Message;
         this.$bvModal.show(this.deleteModal.modalId);
      },
      deleteMessage() {
         let messageObjectForSend = this.formatMessageChannelBeforeSend(
            {
               Message: "remove message!",
               TargetUserId: this.selectedMsg.UserId,
               TargetTimestamp: this.selectedMsg.Timestamp
            },
            RTM_MESSAGE_TYPE.ADMIN_DELETE_MESSAGE
         );
         this.sendNewChannelMessage(messageObjectForSend, this.streamDetail.key);
      }
   },
   async beforeDestroy() {
      await this.clearGetMemberJob();
      this.updateCurrentChannel(null);
      window.removeEventListener("resize", this.scrollToEndChatBox);
      if (document.getElementById("list-messages-box"))
         document.getElementById("list-messages-box").removeEventListener("scroll", this.getElementOverflow);
      await this.updateListChannelMessages([]);
      await this.updateIsJoinedChannel(false);
      await this.myWorker.terminate();
   }
};
